import firebase from 'firebase/app'

const storage = firebase.storage()

export function uploadFile (file, name, onchange) {
  let uploadTask = storage.ref(name)

  if (typeof file === 'string') {
    uploadTask = uploadTask.putString(file, 'raw')
  } else {
    uploadTask = uploadTask.put(file)
  }

  return new Promise((resolve, reject) => {
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100

      if (onchange) {
        onchange(progress, snapshot.state)
      }

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED:
          break
        case firebase.storage.TaskState.RUNNING:
          break
      }
    }, function (error) {
      reject(error)

      switch (error.code) {
        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          break

        case 'storage/canceled':
          // User canceled the upload
          break

        case 'storage/unknown':
          // Unknown error occurred, inspect error.serverResponse
          break
      }
    }, function () {
      uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        resolve(downloadURL)
      })
    })
  })
}

export default storage
